var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import clsx from 'clsx';
import React from 'react';
var style = {
    button: 'rounded-full text-sm w-8 h-8 cursor-pointer my-auto mx-0 text-center',
    background: 'bg-button text-white',
};
export var Primary = function (_a) {
    var className = _a.className, colorClassNames = _a.colorClassNames, props = __rest(_a, ["className", "colorClassNames"]);
    return (React.createElement("button", __assign({}, props, { className: clsx(className, style.button, colorClassNames !== null && colorClassNames !== void 0 ? colorClassNames : style.background) })));
};
